export default __webpack_public_path__ + "static/media/plans-hover.d86595c0.svg";